// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const isDebug = false;
const getEnv = (debug) => {
  if (debug) {
    const BASE_URL = 'http://localhost:8081';
    return {
      production: true,
      isDebug: true,
      MASTERURL: BASE_URL,
      AUTHURL: `https://us-central1-thinkwise-pro.cloudfunctions.net/master-auth`,
      FEESCOLLECTIONURL: `https://us-central1-thinkwise-pro.cloudfunctions.net/fee-master-fees-management`,
      MASTERBULKUPLOADURL: `https://us-central1-thinkwise-pro.cloudfunctions.net/dev-bulkupload`,
      MANOMASTERURL: `https://us-central1-thinkwise-pro.cloudfunctions.net/mano-issues-academics`,
    };
  } else {
    const BASE_URL = 'https://us-central1-thinkwise-pro.cloudfunctions.net';
    return {
      production: true,
      isDebug: true,
      search: 'http://search.medicalconcierge.co.in/api/search/',
      BASE_URL: 'http://us-central1-thinkwise-pro.cloudfunctions.net/',
      // MASTER_SERVICE: 'https://us-central1-thinkwise-pro.cloudfunctions.net/master-academics',
      // AUTH_SERVICE: 'https://us-central1-thinkwise-pro.cloudfunctions.net/master-auth',
      // FEE_COLLECTION_SERVICE: 'https://us-central1-thinkwise-pro.cloudfunctions.net/fee-master-fee-management',
      // BULK_UPLOAD_SERVICE: 'https://us-central1-thinkwise-pro.cloudfunctions.net/dev-bulkupload',
    };
  }
};
export const environment = getEnv(isDebug);
// 'http://localhost:8081', //
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

// BULK_UPLOAD_SERVICE: 'http://localhost:8080'
// BULK_UPLOAD_SERVICE: 'https://us-central1-thinkwise-pro.cloudfunctions.net/dev-bulkupload'
